<template>
  <v-card>
    <v-card-title v-if="displaySearch">
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="tableData"
      :loading="loading"
      :options.sync="options"
      :server-items-length="totalCount"
      :hideActions="hideActions"
      :hideHeaders="hideHeaders"
    >
      <template #[`item.on_hand`]="{ item }">
        {{ item.on_hand }}
        <v-chip color="red" class="ml-2" x-small dark v-if="item.on_hand < item.low_stock_limit">low</v-chip>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
          v-if="item.status == 'active'"
          color="green"
          text
          label
          small
        >
          Active
        </v-chip>
        <v-chip
          v-else-if="item.status == 'inactive'"
          color="red"
          text
          label
          small
        >
          Inactive
        </v-chip>
      </template>
      <template #[`item.available`]="{item}">
        <b>{{ item.available }}</b>
      </template>
      <template v-slot:item.actions="{item}">
        <v-btn icon @click.stop="open(item.id)" v-if='$can("price", "Product")'>
          <v-icon small>mdi-dots-horizontal</v-icon>
        </v-btn>
        <v-btn icon @click.stop="toggleAcivate(item.id)" v-if='$can("price", "Product")'>
          <v-icon small>{{item.status=='active' ? 'mdi-close' : 'mdi-check'}}</v-icon>
        </v-btn>
        <delete-product :product="item.id" v-if='$can("price", "Product")' @reload="getProducts" />
        
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import _ from "lodash";
import DeleteProduct from "./DeleteProduct.vue"

export default {
  components: {DeleteProduct},
  props: {
    store: {
      type: String
    },
    headers: {
      type: Array
    },
    filters: {
      type: Object
    },
    displaySearch: {
      type: Boolean,
      default: true
    },
    hideHeaders: {
      type: Boolean,
      default: false
    },
    hideActions: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      search: "",
      options: { rowsPerPage: 15 },
      editedPrice: null,
      priceFormOpen: false,
      selectedFilters: this.filters,
      tableData: [],
      totalCount: 0,
      loading: false
    };
  },
  watch: {
    options: {
      handler: _.debounce(function() {
        this.getProducts();
      }, 100)
    },
    search: {
      handler: _.debounce(function() {
        this.getProducts();
      }, 100)
    },
    filters: function(newVal) {
      if (JSON.stringify(this.selectedFilters) !== JSON.stringify(newVal)) {
        this.selectedFilters = Object.assign({}, this.selectedFilters, newVal);
        this.getProducts();
      }
    }
  },
  computed: {
    filterValues: function() {
      return this.$store.getters["products/filterValues"];
    },
    currencies: function() {
      return this.$store.getters["currencies/currencies"];
    }
  },
  mounted: function() {
    this.getProducts(); //method1 will execute at pageload
  },
  methods: {
    getProducts() {
      this.loading = true;
      this.$store
        .dispatch(this.store, {
          pagination: this.options,
          search: this.search,
          filters: this.selectedFilters,
          expand: "set,catalogs,prices,skuProduct"
        })
        .then(({products}) => {
          this.tableData = products.data;
          this.totalCount = products.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
      this.getProducts();
    },
    columnValueList(val) {
      return this.tableData.map(d => d[val]);
    },
    open(id) {
      this.$router.push("/products/view/" + id);
    },
    toggleAcivate(id) {
      this.$store.dispatch("products/toggleActivate", id).then(() => {
        this.getProducts();
      });
    },
    getPrice(product, catalogId, currency) {
      for (let index = 0; index < product.prices.length; index++) {
        const price = product.prices[index];
        if (price.catalog_id == catalogId && price.currency == currency)
          return price.type == "upcharge" ? "+" + price.price : price.price;
      }
      return 0;
    },
    getBaseProduct(product, catalogId) {
      for (let index = 0; index < product.catalogs.length; index++) {
        const catalog = product.catalogs[index];
        if (catalog.catalog_id == catalogId) return catalog.baseProduct ? "x" : "";
      }
      return "";
    }
  }
};
</script>

<style lang="less" scoped></style>
